import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PlaylistsAPI } from "../../api/api";
import "./Playlists.css"

export default function PlaylistsSettings() {
    const [playlists, setPlaylists] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [newPlaylistName, setNewPlaylistName] = useState("");
    const [newPlaylistIsRandomEnabled, setNewPlaylistIsRandomEnabled] = useState(true);
    const [editedPlaylistName, setEditedPlaylistName] = useState("");
    const [editedPlaylistIsRandomEnabled, setEditedPlaylistIsRandomEnabled] = useState(true);
    const [editedPlaylist, setEditedPlaylist] = useState(null);

    const navigate = useNavigate();

    const loadPlaylists = async () => {
        try {
            setLoading(true);
            const data = await PlaylistsAPI.getAll();
            setPlaylists(Array.isArray(data.data) ? data.data : []);
        } catch (err) {
            console.error("Failed to load playlists:", err);
            setPlaylists([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadPlaylists();
    }, []);

    const handleCreate = async () => {
        if (!newPlaylistName.trim()) return;
        const payload = { name: newPlaylistName, isRandomEnabled: newPlaylistIsRandomEnabled }
        try {
            setLoading(true);
            await PlaylistsAPI.create(payload);
            setShowAddModal(false);
            setNewPlaylistName("");
            loadPlaylists();
        } catch (err) {
            console.error("Failed to create playlist:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = async (playlist) => {
        if (!editedPlaylistName.trim()) {
            setShowEditModal(false);
            return;
        }
        if (playlist.name === editedPlaylistName.trim() && playlist.isRandomEnabled === editedPlaylistIsRandomEnabled) {
            setShowEditModal(false);
            return
        }

        const payload = { id: playlist.id, name: editedPlaylistName.trim(), isRandomEnabled: editedPlaylistIsRandomEnabled }
        try {
            setLoading(true);
            await PlaylistsAPI.update(payload);
            setShowEditModal(false);
            setNewPlaylistName("");
            loadPlaylists();
        } catch (err) {
            console.error("Failed to create playlist:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            setLoading(true);
            await PlaylistsAPI.delete(id);
            loadPlaylists();
        } catch (err) {
            console.error("Failed to delete playlist:", err);
        } finally {
            setLoading(false);
        }
    };

    const checkboxHandler = async () => {
        setNewPlaylistIsRandomEnabled(!newPlaylistIsRandomEnabled);
    }

    const editCheckboxHandler = async () => {
        setEditedPlaylistIsRandomEnabled(!editedPlaylistIsRandomEnabled);
    }

    const playlistTableDisplay = () => {
        return (
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="p-id">#</th>
                            <th className="ps-name">Name</th>
                            <th className="ps-random">Is Random Enabled</th>
                            <th className="p-btn"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {playlists.map((playlist, i) => (
                            <tr key={playlist.id}>
                                <td className="p-id">{i + 1}</td>
                                <td className="ps-name">{playlist.name}</td>
                                <td className="ps-random">
                                    <div>
                                        {playlist.isRandomEnabled
                                            ? <i className="fa-solid fa-check"></i>
                                            : <i className="fa-regular fa-square"></i>}
                                    </div>
                                </td>
                                <td className="p-btn">
                                    <button
                                        onClick={() => {
                                            setShowEditModal(true)
                                            setEditedPlaylist(playlist)
                                            setEditedPlaylistIsRandomEnabled(playlist.isRandomEnabled)
                                            setEditedPlaylistName(playlist.name)
                                        }}
                                        className="edit-btn"
                                    >
                                        <i className="fas fa-edit"></i>
                                    </button>
                                    <button
                                        onClick={() => handleDelete(playlist.id)}
                                        className="del-btn"
                                    >
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    const buttonTabs = () => {
        return (
            <div className="playlists-tabs-container">
                <div className="playlist-tabs">
                    <div className="pl-main-btn"><button onClick={() => setShowAddModal(true)} className="add-btn" >ADD</button></div>
                    <div className="pl-main-btn"><button onClick={() => navigate(`/playlists`)} className="add-btn" >BACK</button></div>

                </div>
            </div>
        );
    };

    const editPlaylistModal = () => {
        return (<div className="playlists-modal-overlay">
            <div className="playlists-modal">
                <div className="pl-modal-name">
                    <h2>Edit Playlist</h2>
                    <h3>{editedPlaylist.name}</h3>
                    <input
                        name="playlist-edit"
                        type="text"
                        value={editedPlaylistName}
                        onChange={(e) => setEditedPlaylistName(e.target.value)}
                        placeholder="Enter new playlist name"
                    />
                </div>
                <div className="pl-modal-check">
                    <h3>Enable Random</h3>
                    <div onClick={() => editCheckboxHandler()}>
                        {editedPlaylistIsRandomEnabled
                            ? <i className="fa-solid fa-check"></i>
                            : <i className="fa-regular fa-square"></i>}
                    </div>
                </div>

                <div className="playlists-modal-buttons">
                    <button onClick={() => handleEdit(editedPlaylist)} className="playlists-edit-btn">Edit</button>
                    <button onClick={() => setShowEditModal(false)} className="playlists-cancel-btn">Cancel</button>
                </div>
            </div>
        </div>);
    };

    const addPlaylistModal = () => {
        return (
            <div className="playlists-modal-overlay">
                <div className="playlists-modal">
                    <div className="pl-modal-name">
                        <h2>Create Playlist</h2>
                        <input
                            name="playlist-create"
                            type="text"
                            value={newPlaylistName}
                            onChange={(e) => setNewPlaylistName(e.target.value)}
                            placeholder="Enter playlist name"
                        />
                    </div>
                    <div className="pl-modal-check">
                        <h3>Enable Random</h3>
                        <div className="check" onClick={() => checkboxHandler()}>
                            {newPlaylistIsRandomEnabled
                                ? <i className="fa-solid fa-check"></i>
                                : <i className="fa-regular fa-square"></i>}
                        </div>
                    </div>

                    <div className="playlists-modal-buttons">
                        <button onClick={handleCreate} className="playlists-create-btn">Create</button>
                        <button onClick={() => setShowAddModal(false)} className="playlists-cancel-btn">Cancel</button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="playlists-main">
            <div className="playlists-page-main">
                <div className="playlists-main-title"><h1>PLAYLISTS SETTINGS</h1></div>
                {loading
                    ? <div className="spinner"></div>
                    : <div className="table-main">
                        {buttonTabs()}
                        {playlistTableDisplay()}
                    </div>}

                {showAddModal && addPlaylistModal()}
                {showEditModal && editPlaylistModal()}
            </div>
        </div>
    );
};